<template>
    <div class="testimonial">
        <div v-if="loading">
            <Spinner size="large" message="Loading..." line-fg-color="#000" style="padding: 5rem 0;"/>
        </div>
        <div v-else-if="nodata">
            Sorry, we can't found your data, please try to access another page.
        </div>
        <vueper-slides 
            autoplay
            fade
            :bullets="window.width > 576 ? false : true"
            :arrows="window.width > 576 ? true : false"
            class="no-shadow slide"
            :touchable="false"
            :pauseOnHover="false"
            :duration="5000"
            :fixed-height="true"
            v-else
            >
            <vueper-slide
                v-for="(slide, i) in data"
                :key="i"
                class="testimonialSlide">
                <template v-slot:content>
                    <div class="slideContent">
                        <p>
                            "{{slide.Content}}"
                        </p>
                        <p>
                            - {{slide.Name}}
                        </p>
                    </div>
                </template>
            </vueper-slide>
        </vueper-slides>
    </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides';
import Spinner from 'vue-simple-spinner';

export default {
    name: "Testimonial",
    components: { VueperSlides, VueperSlide, Spinner },
    data() {
        return {
            data: [],
            loading: true,
            nodata: false,
            window: {
                width: 0,
                height: 0
            }
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },
    mounted:function(){
        this.axios.get(`https://api.minnesotapremierrealty.com/testimonials`)
        .then((response) => {
            if(response.data.length === 0){
                this.nodata = true;
            } else {
                this.data = response.data;
                this.loading = false;
            }
        })
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
}
</script>

<style lang="scss" scoped>
.testimonial{
    background-color: #2260ad;
    color: #fff;
    text-align: center;
}
.testimonialSlide{
    display: flex;
    padding: 0 2rem;
}
.slideContent{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 800px;
    margin: 0 auto;
}

.vueperslides--fixed-height { height: 300px; }

@media (max-width: $mobile) { 
    .vueperslides--fixed-height { height: 400px; }
}

</style>

<style lang="scss">
.testimonial{
    .vueperslides__bullets{
        bottom: 30px;
        .default {
            width:6px;
            height:6px;
            border-radius: 6px;
            color: #fff;
            background-color: #fff;
            box-shadow: none;
        }
    }
    .vueperslides__bullet--active{
        .default {
            width:6px;
            height:6px;
            border-radius: 6px;
            color: #ccc;
            background-color: #ccc;
            border-width: unset;
            box-shadow: none;
        }
    }
}
</style>